/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".summary-container[_ngcontent-%COMP%]{margin-top:.5rem}.summary-container[_ngcontent-%COMP%]   .summary-label[_ngcontent-%COMP%]:not(:nth-child(0)){font-size:18px;padding-top:.1rem}"];
export { styles as styles };

